export enum FixedFilters {
  None = 0,
  Event = 1,
  VenueZone = 2,
}
